import React from 'react'
import PropTypes from 'prop-types'
import {frnt, Theme} from '@frnt/base/themes'
import styled, {css} from 'styled-components'

const theme = ({selector = '&&&', theme}) => css`
  .mdc-theme--${theme} ${selector} rect {
    fill: var(--mdc-theme-${theme});
  }
  .mdc-theme--on-${theme} ${selector} path {
    fill: var(--mdc-theme-on-${theme});
  }
  .mdc-theme--text-neutral-on-${theme} ${selector} path {
    fill: var(--mdc-theme-text-neutral-on-${theme});
  }
  .mdc-theme--text-primary-on-${theme} ${selector} path {
    fill: var(--mdc-theme-text-primary-on-${theme});
  }
  .mdc-theme--text-primary2-on-${theme} ${selector} path {
    fill: var(--mdc-theme-text-primary2-on-${theme});
  }
`

const StyledSvg = styled.svg`
  ${theme({theme: 'primary'})};
  ${theme({theme: 'primary2'})};
  ${theme({theme: 'neutral'})};
`

const FrntIcon = ({theme}) => {
  const color = frnt.primary
  const backgroundColor = frnt.onPrimary

  return (
    <Theme use={theme}>
      <StyledSvg width="36px" height="36px" viewBox="0 0 434 434" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="434" height="434" rx="31.8133" fill={backgroundColor} />
        <path
          d="M224.351 348.15C224.351 350.685 222.196 352.483 219.865 352.483H192.782C188.12 352.483 185.073 351.22 183.459 347.97L146.509 274.614V348.15C146.509 350.685 144.715 352.483 142.203 352.483H118.708C116.197 352.483 114.222 350.685 114.222 348.15V230.351C114.222 228.007 116.197 226.018 118.708 226.018H150.989C153.5 226.018 155.655 226.736 157.09 229.633L192.064 300.817V230.351C192.064 228.007 194.039 226.018 196.37 226.018H219.865C222.196 226.018 224.351 228.007 224.351 230.351V348.15Z"
          fill={color}
        />
        <path
          d="M235.732 256.727C233.33 256.727 231.445 254.738 231.445 252.213V230.542C231.445 228.007 233.33 226.018 235.732 226.018H337.288C339.69 226.018 341.575 228.007 341.575 230.542V252.213C341.575 254.738 339.69 256.727 337.288 256.727H301.949V347.966C301.949 350.491 300.061 352.48 297.659 352.48H275.36C272.958 352.48 271.069 350.491 271.069 347.966V256.727H235.732Z"
          fill={color}
        />
        <path
          d="M146.985 213.122C146.985 215.649 145.068 217.993 142.544 217.993H119.103C116.578 217.993 114.222 215.649 114.222 213.122V95.4366C114.222 93.0926 116.578 91.4704 119.103 91.4704H220.057C222.581 91.4704 224.353 93.0926 224.353 95.629V117.314C224.353 119.841 222.581 122.211 220.057 122.211H146.985V143.033H204.549C207.074 143.033 208.564 144.608 208.564 147.142V168.835C208.564 171.362 207.074 173.968 204.549 173.968H146.985V213.122Z"
          fill={color}
        />
        <path
          d="M235.781 217.81C233.368 217.81 231.469 216.011 231.469 213.477V95.6799C231.469 93.6908 232.847 91.3468 235.781 91.3468H294.702C320.567 91.3468 335.393 110.311 335.393 130.731C335.393 142.122 330.739 155.13 316.602 163.066L340.738 211.67C341.253 212.568 341.601 213.659 341.601 214.557C341.601 216.374 340.397 217.81 337.983 217.81H312.118C308.326 217.81 306.947 217.092 305.222 213.124L288.155 173.186H262.503V213.296C262.503 215.821 260.604 217.81 258.191 217.81H235.781ZM262.503 120.621V146.271H288.495C296.257 146.271 302.806 141.565 302.806 133.083C302.806 124.59 296.257 120.621 288.842 120.621H262.503Z"
          fill={color}
        />
      </StyledSvg>
    </Theme>
  )
}

FrntIcon.propTypes = {
  theme: PropTypes.array
}

export {FrntIcon}
